import * as React from "react";
import {cx} from "emotion";

import "./actions.scss";

import {AnyAction}      from "@Common/react/any-action";
import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {fragments}      from "@Common/react/fragments";
import {scn}            from "@Common/react/state-change-nested-value";
import {UseState}       from "@Common/react/use-state";
import {buildUrlQuery}  from "@Common/utils/build-url-query";
import {isNotEmpty}     from "@Common/utils/objects";

import {OrderDetailsSidebar}       from "../../../../../account/orders/common/order-details/order-details-sidebar";
import {DenyConfirmModal}          from "../../../../../approval-requests/common/deny-confirm-modal/deny-confirm-modal";
import {DenySuccessModal}          from "../../../../../approval-requests/common/deny-success-modal/deny-success-modal";
import {InternalLink}              from "../../../../../common/components/internal-link";
import {mapCartItemToOrderDetails} from "../../../../../common/map-cart-item-to-order-details";
import {reloadCart}                from "../../store/actions/reload-cart";

export const Actions = ({item, hasMultipleItems, store, isFromApproval, removing, confirmModal}) => cs(
    consumeContext("apis"),
    consumeContext("session"),

    consumeContext("cart"),
    consumeContext("routerHistory"),
    ["orderDetailsSidebar", (_, next) => OrderDetailsSidebar({next})],
    ["denyConfirmModal", (_, next) => DenyConfirmModal({next})],
    ["denySuccessModal", ({apis}, next) => DenySuccessModal({onClose: () => store.dispatch(reloadCart({apis})), next})],
    ({apis, cart: rootCart, orderDetailsSidebar, session, denyConfirmModal, denySuccessModal, routerHistory}) => (
        <div className="actions actions-3g0">
            {cs(
                consumeContext("company"),
                ["options", (_, next) => UseState({next})],

                ({options}, next) => fragments(
                    next(),
                    options.value && AnyAction({
                        action: () => options.onChange(null),
                    }),
                ),
                ({options, company}) => (
                    <button
                        xd-qa-name="Edit Options"
                        className={cx("edit",
                            {
                                clicked: options.value, 
                                "reproof": item?.isReproofRequired, 
                                "unavailable": !item?.isAvailableItem
                            }
                        )}
                        xd-qa-type="button"
                        onClick={() => options.change(v=>!v)}
                    >
                        EDIT <i className={cx("fa", !options.value ? "fa-caret-down" : "fa-caret-up")}/>
                        {options.value && (
                            <div className="dropdown">
                                <InternalLink
                                    className="dropdown-item"
                                    xd-qa-type="dropdown_item"
                                    xd-qa-name="Product Options"
                                    to={`/product-options/order/${item.itemId}` + buildUrlQuery({
                                        ...isFromApproval && {
                                            id_cart: store.cart.cartId,
                                            referrer: "approval-requests"
                                        },
                                    })}
                                >
                                    Product Options
                                </InternalLink>
                                {company?.prefs?.xpressoKitOptionsActive && (isNotEmpty(item?.components)) && (
                                    <InternalLink
                                        className="dropdown-item"
                                        xd-qa-type="dropdown_item"
                                        xd-qa-name="Kit Options"

                                        to={`/kit-options/order/${item.itemId}` + buildUrlQuery({
                                            ...isFromApproval && {
                                                id_cart: store.cart.cartId,
                                                referrer: "approval-requests"
                                            }
                                        })
                                        }
                                    >
                                        Kit Options
                                    </InternalLink>
                                )}
                                {item.source !== "OIA" && !item.uyoMPB && item.proofEngineType === 7 && !company?.prefs?.allowBuild3 && (!isNotEmpty(item?.components)) && ( //Xpressproof
                                    <a
                                        href={`/next/start.php` + buildUrlQuery({
                                            action: "edit",
                                            id_order: item.itemId,
                                            order_exists: "exists",
                                            procform: 1,
                                            redirect: "customize",
                                            ...isFromApproval && {
                                                approval: 1,
                                            }
                                        })}
                                        className="dropdown-item"
                                        xd-qa-type="dropdown_item"
                                        xd-qa-name="Customize"
                                    >
                                        Customize
                                    </a>
                                )}
                                {item.source !== "OIA" && !item.uyoMPB && ( (!item.proofEngineType && item.idProductType !== 6) || company?.prefs?.allowBuild3 ) && (!isNotEmpty(item?.components)) && (//Customer Canvas except pick-pack and default if proofEngineType missing
                                    <InternalLink
                                        className="dropdown-item"
                                        xd-qa-type="dropdown_item"
                                        xd-qa-name="Customize"
                                        to={`/customize/order/${item.itemId}` + buildUrlQuery({
                                            ...isFromApproval && {
                                                id_cart: store.cart.cartId,
                                                referrer: "approval-requests"
                                            },
                                        })}
                                    >
                                        Customize
                                    </InternalLink>
                                )}
                                {(item.addressable) && (
                                    <InternalLink
                                        className="dropdown-item"
                                        xd-qa-type="dropdown_item"
                                        xd-qa-name="Distribution Options"

                                        to={`/distribution-options/order/${item.itemId}`
                                            + buildUrlQuery({
                                                ...isFromApproval && {
                                                    id_cart: store.cart.cartId,
                                                    referrer: "approval-requests"
                                                }
                                            })
                                        }
                                    >
                                        Distribution Options
                                    </InternalLink>
                                )}
                            </div>
                        )}
                    </button>
                )
            )}


            <div className="actions">
                <a {...{
                    "xd-qa-type": "link",
                    "xd-qa-name": "Item Details",
                    // className: "remove",
                    onClick: () => orderDetailsSidebar.show({
                        orderDetails: {
                            item: mapCartItemToOrderDetails(item),
                            displayOrderTotal: false,
                            displayKitOptions : false,
                        },
                    }),
                }}>
                    { isNotEmpty(item?.components) ? 'View Kit Details' : 'Details' }
                </a>

                {removing.value ? (
                    <div className="status">
                        Removing...
                    </div>
                ) : (!isFromApproval || hasMultipleItems) && (
                    isFromApproval ? (
                        <a
                            xd-qa-type="link"
                            xd-qa-name="Remove Item"
                            // className="danger"
                            onClick={async () => {
                                    denyConfirmModal.show({
                                        confirm: async () => {
                                            const result = await apis.next.approval.denyCcOrder({cartId: store.cart.cartId, orderId: item.itemId});

                                            if (result.result === "success") {
                                                denySuccessModal.show({email: session?.data?.agent?.agentEmail, id: item.itemId, type: "Order"});
                                                return {success: true};
                                            } else {
                                                return {success: false, error: result.errors.msg};
                                            }
                                        },
                                    });
                                }
                            }
                        >
                            Deny
                        </a>
                    ) : (
                        item.programType != "Scheduled Campaigns" ? (
                            <a
                                xd-qa-type="link"
                                xd-qa-name="Remove Item"
                                // className="remove"
                                onClick={() => {
                                    confirmModal.show({
                                        messageLines: ["Are you sure you want to remove this order?",
                                            "Your order will be removed from your cart and saved in Pending Orders."],
                                        confirm: async () => {
                                            removing.onChange(true);
                                            await apis.next.cart.deleteItemsFromCart({cartId: store.cart.cartId, itemIds: [item.itemId]});

                                            if (store.cart.items.length > 1) {
                                                await store.dispatch(reloadCart({apis}));
                                            } else {
                                                scn(rootCart, ["items"], () => []);
                                                routerHistory.push("/");
                                            }
                                        }
                                    })
                                }}
                            >
                                Remove
                            </a>
                        ) : ""
                    )

                )}
            </div>

        </div>
    ),
);

